import Menu from './Menu';
import Tabs from './Tabs';

export default { Tabs, Menu };
